import React from 'react'
import { Box, Container, Typography } from "@mui/material";

function TopHeader({clinicData}) {

  return (
    <>
    {/* Top Header */}
         <Box
           sx={{
             width: "100%",
             backgroundColor: `${clinicData.primaryColor}`,
             padding: 2,
             position: "absolute",
             top: 0,
             boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
             display: { xs: "none", md: "flex" }, // Hide clinic info on mobile
             justifyContent: "space-between",
           }}
         >
           <Container
             maxWidth="lg"
             sx={{
               display: "flex",
               justifyContent: "space-between",
               alignItems: "center",
             }}
           >
             <img
               src={clinicData.logo}
               alt="Clinic Logo"
               style={{ maxWidth: "500px", borderRadius: "8px" }}
             />
             <Box sx={{ textAlign: "right" }}>
               <Typography
                 variant="h6"
                 sx={{ color: clinicData.secondaryColor, fontWeight: "bold" }}
               >
                 {clinicData.clinicName}
               </Typography>
               <Typography sx={{ fontSize: "14px", color: "#555" }}>
                 {clinicData.address}
               </Typography>
               <Typography sx={{ fontSize: "14px", color: "#555" }}>
                 📞 {clinicData.phone} | 📠 {clinicData.fax}
               </Typography>
             </Box>
           </Container>
         </Box>
   
         {/* Logo for Mobile */}
         <Box
           sx={{
             display: { xs: "flex", md: "none" },
             justifyContent: "center",
             alignItems: "center",
             width: "100%",
             mt: 4,
           }}
         >
           <img
             src={clinicData.logo}
             alt="Clinic Logo"
             style={{ maxWidth: "600px" }}
           />
         </Box>
  </>
  )
}

export default TopHeader